import React, { useState, useEffect, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Tab, Tabs, Dropdown, Row, Col } from 'react-bootstrap';
import { setSearchParams, reportSearchParams } from '../../actions/analyze';
import { showOverlay, hideOverlay } from '../../actions/toast';
import { getSettings } from '../../actions/user';
import { toCustomDate } from '../../helpers/moment-ex';
import { isCustom, isYesterday, isToday, isAbsolute, parseToMoment } from '../../helpers/common';
import QuickSelection from './QuickSelection';
import AbsoluteDate from './AbsoluteDate';
import RangeBoxDate from './RangeBoxDate';
import RangeBoxYear from './RangeBoxYear';
import { getCustomRangeType, getRangeType, getCustomDate } from '../../helpers/session';
import { RANGE_TYPE_TODAY, RANGE_TYPE_CUSTOM, rangeList, RANGE_TYPE_ABSOLUTE, DISPLAY_DATE_FORMAT2, API_DATETIME_FORMAT, RANGE_TYPE_YESTERDAY } from '../../constants';
import '../../../assets/scss/header-submenu.scss';

const RangeBox = (props) => {
    const dispatch = useDispatch();

    const searchParams = useSelector(state => state.analyze.searchParams);
    const isToggleRetainDate = useSelector(state => state.analyze.isToggleRetainDate);
    const timezoneIdentifier = useSelector(state => state.farm.currentFarm.timezone_identifier);
    const settings = useSelector(state => state.user.userSettings);

    //const { searchParams, timezoneIdentifier, settings, isToggleRetainDate } = props;
    const { farmId } = props.match.params;
    const reportedDate = settings.report_date_range;

    const [show, setShow] = useState(false);
    const [tab, setTab] = useState(1);
    const [isTodayDate, setTodayDate] = useState(true);
    const [singleDate, setSingleDate] = useState(true);
    const [showToggle, setShowToggle] = useState(false);
    const [selectedYear, setSelectedYear] = useState(undefined);
    const [disableTab, setDisableTab] = useState(false);

    useEffect(() => {
        const range = getRangeType(timezoneIdentifier) || RANGE_TYPE_TODAY;
        const customRange = getCustomRangeType(timezoneIdentifier) || range;

        if (reportedDate === undefined) {
            dispatch(showOverlay({ text: "Loading..." }));
            const cb = () => {
                dispatch(hideOverlay());
            };
            dispatch(getSettings(cb));
        }

        if (isAbsolute(customRange)) {
            const dateObj = getCustomDate(timezoneIdentifier);
            const dateInfo = { custom: dateObj, absolute: dateObj };
            dispatch(setSearchParams({ range, customRange, ...dateInfo }));
        } else onChangeSearchRange({ range, customRange });

    }, [farmId]);

    useEffect(() => {
        if (!isToggleRetainDate && settings && settings.is_retain_last_selected_date && reportedDate && reportedDate.absolute.from !== null && reportedDate.absolute.from !== "Invalid date") {
            const from = reportedDate.absolute.from;
            const to = reportedDate.absolute.to;
            const dateObj = toCustomDate(from, to);
            const dateInfo = { custom: dateObj, absolute: dateObj };

            const range = RANGE_TYPE_CUSTOM;
            const customRange = RANGE_TYPE_ABSOLUTE;

            if (reportedDate.rangeId === "absolute") dispatch(setSearchParams({ range, customRange, ...dateInfo }));
            else if (reportedDate.rangeId === "today" || reportedDate.rangeId === "yesterday" ||
                reportedDate.rangeId === "planned" || reportedDate.rangeId === "todate") {
                    dispatch(setSearchParams({ range: reportedDate.rangeId, customRange: reportedDate.rangeId, ...dateInfo }));
            }
            else onChangeSearchRange({ range, customRange: reportedDate.rangeId });
        } else if (settings && reportedDate && reportedDate.absolute.from !== null && reportedDate.absolute.from !== "Invalid date") {
            dispatch(hideOverlay());
        }
    }, [reportedDate]);

    useEffect(() => {
        if (show === false) isAbsolute(getCustomRangeType(timezoneIdentifier)) ? setTab(2) : setTab(1);
    }, [show, farmId]);

    useEffect(() => {
        /* const timeFormat = DISPLAY_DATE_FORMAT2;
        const now = moment.utc().tz(timezoneIdentifier).format(timeFormat);
        const fromDate = moment(searchParams.custom.from).format(timeFormat);
        const toDate = moment(searchParams.custom.to).format(timeFormat);
        const currentYear = moment(now).year();
        const selectedYear = moment(fromDate).year(); */

        const customFrom = parseToMoment(searchParams.custom.from);
        const customTo = parseToMoment(searchParams.custom.to);

        const timeFormat = DISPLAY_DATE_FORMAT2;
        const now = moment.utc().tz(timezoneIdentifier);
        const fromDate = moment(customFrom).format(timeFormat);
        const toDate = moment(customTo).format(timeFormat);
        const currentYear = now.year();
        const selectedYear = customFrom ? customFrom.year() : null;

        (searchParams.customRange === "planned" || searchParams.customRange === "todate") ? setShowToggle(false) : setShowToggle(true);

        if (now === fromDate) {
            setSingleDate(true);
            setTodayDate(true);
        } else {
            setSingleDate(false);
            setTodayDate(false);
        }

        if (selectedYear === currentYear || searchParams.customRange === "planned" || searchParams.customRange === "todate") {
            setDisableTab(false);
        } else {
            setTab(2);
            setDisableTab(true);
        }

        fromDate === toDate ? setSingleDate(true) : setSingleDate(false);

        if (reportedDate && reportedDate.absolute.from && searchParams.custom.from === reportedDate.absolute.from) dispatch(hideOverlay());

        if (searchParams.custom.from !== null && settings.hasOwnProperty('report_date_range')) dispatch(reportSearchParams({ rangeId: searchParams.customRange, absolute: { from: searchParams.custom.from, to: searchParams.custom.to } }));
    }, [searchParams, settings]);

    useEffect(() => {
        if (selectedYear !== undefined) {
            /* const fromDate = moment(searchParams.custom.from).format("DD MMM");
            const toDate = moment(searchParams.custom.to).format("DD MMM");
            const selectedFromDate = moment(`${fromDate} ${selectedYear}`).startOf("days");
            const selectedToDate = moment(`${toDate} ${selectedYear}`).endOf("days"); */

            const fromDate = moment(searchParams.custom.from, "YYYY-MM-DD HH:mm:ss").format("DD MMM");
            const toDate = moment(searchParams.custom.to, "YYYY-MM-DD HH:mm:ss").format("DD MMM");
            const selectedFromDate = moment(`${fromDate} ${selectedYear}`, "DD MMM YYYY").startOf("days");
            const selectedToDate = moment(`${toDate} ${selectedYear}`, "DD MMM YYYY").endOf("days");

            const range = RANGE_TYPE_CUSTOM;
            const customRange = RANGE_TYPE_ABSOLUTE;

            const dateObj = toCustomDate(selectedFromDate, selectedToDate);
            dispatch(setSearchParams({ range, customRange, custom: dateObj, absolute: dateObj }));
        }
    }, [selectedYear]);

    const handleRangeChange = (item) => {
        setShow(!show);
        let range = null;
        if (item.unit) range = RANGE_TYPE_CUSTOM;
        else range = item.id;
        onChangeSearchRange({ range, customRange: item.id });
    };

    const getCustomDateRange = (item) => {
        const now = moment.utc().tz(timezoneIdentifier);
        const custom = {
            from: null,
            to: null
        };

        if (item.id === 'thisYear') {
            const currentYear = moment(now).year();
            custom.from = moment(`${currentYear}-01-01`).startOf(item.unit);
            custom.to = moment(now).endOf("days");
            return custom;
        }

        if (item.method) {
            if (item.method === "startOf") {
                custom.from = moment(now).startOf(item.unit);
                custom.to = moment(now).endOf("days");
            }
        } else {
            custom.to = moment(now).endOf(item.unit);
            custom.from = moment(now).subtract(item.amount - 1, item.unit).startOf(item.unit);
        }

        return custom;
    };

    const onChangeSearchRange = ({ range, customRange }) => {
        const now = moment.utc().tz(timezoneIdentifier);
        const selectedRangeSet = rangeList.filter(e => e.id === customRange);
        let custom = null;

        if (isCustom(range)) {
            const dateObj = getCustomDateRange(selectedRangeSet[0]);
            custom = toCustomDate(dateObj.from, dateObj.to);
        }
        else if (isYesterday(range)) {
            const start = moment(now).subtract(1, "days").startOf("days");
            const end = moment(now).subtract(1, "days").endOf("days");
            custom = toCustomDate(start, end);
        }
        else if (isToday(range)) {
            const start = moment(now).startOf("days");
            const end = moment(now).endOf("days");
            custom = toCustomDate(start, end);
        }

        dispatch(setSearchParams({ range, customRange, ...custom && { custom } }));
    };

    const handleClick = (name) => {
        const fromDate = moment(searchParams.custom.from);
        // const toDate = moment(searchParams.custom.to);
        const todayDate = moment().format(API_DATETIME_FORMAT);
        const today = moment(todayDate).format("DD MMM YYYY");
        const yesterday = moment(todayDate).subtract(1, "days").format("DD MMM YYYY");

        let customRange = RANGE_TYPE_ABSOLUTE;

        if (name === "previous") {
            const startDate = moment(fromDate).subtract(1, "days").startOf("days");
            const endDate = moment(fromDate).subtract(1, "days").endOf("days");
            const dateObj = toCustomDate(startDate, endDate);
            let range = "custom";

            const from = moment(startDate).format("DD MMM YYYY");
            const to = moment(endDate).format("DD MMM YYYY");

            if (from === to && from === today) {
                range = RANGE_TYPE_TODAY;
                customRange = "today";
            } else if (from === to && from === yesterday) {
                range = RANGE_TYPE_YESTERDAY;
                customRange = "yesterday";
            } else {
                range = "custom";
            }

            dispatch(setSearchParams({ range, customRange, custom: dateObj, absolute: dateObj }));
        }

        else {
            const startDate = moment(fromDate).add(1, "days").startOf("days");
            const endDate = moment(fromDate).add(1, "days").endOf("days");
            const dateObj = toCustomDate(startDate, endDate);

            const from = moment(startDate).format("DD MMM YYYY");
            const to = moment(endDate).format("DD MMM YYYY");
            let range = "custom";

            if (from === to && from === today) {
                customRange = "today";
                range = RANGE_TYPE_TODAY;
            } else if (from === to && from === yesterday) {
                customRange = "yesterday";
                range = RANGE_TYPE_YESTERDAY;
            }

            dispatch(setSearchParams({ range, customRange, custom: dateObj, absolute: dateObj }));
        }
    };

    return (
        <Dropdown
            onToggle={() => setShow(!show)}
            show={show}
            className="my-auto"
        >
            <Row>
                <Col style={{ width: "40px" }} className="pr-0">
                    <button
                        onClick={() => handleClick("previous")}
                        title="Previous Day"
                        style={{
                            opacity: !(singleDate && showToggle) ? "50%" : "100%",
                            cursor: !(singleDate && showToggle) ? "not-allowed" : "pointer"
                        }}
                        disabled={!(singleDate && showToggle)}>
                        <i className="fa fa-angle-left" style={{ color: "white", fontSize: "33px" }} />
                    </button>
                </Col>

                <Col className="px-0 d-flex">
                    <div className='mr-2' >
                        <Dropdown.Toggle className="btn-range-date m-0">
                            <RangeBoxDate />
                        </Dropdown.Toggle>
                    </div>
                </Col>

                <Col style={{ width: "40px" }} className="pr-1 pl-0">
                    <button
                        onClick={() => handleClick("next")}
                        title="Next Day"
                        style={{
                            opacity: !(!isTodayDate && singleDate && showToggle) ? "50%" : "100%",
                            cursor: !(!isTodayDate && singleDate && showToggle) ? "not-allowed" : "pointer"
                        }}
                        disabled={!(!isTodayDate && singleDate && showToggle)}>
                        <i className="fa fa-angle-right" style={{ color: "white", fontSize: "33px" }} />
                    </button>
                </Col>

                <Col className="pl-0">
                    <div className='mt-2 pl-0 pr-3'>
                        <RangeBoxYear currentSelectedYear={selectedYear} selectedYear={(year) => setSelectedYear(year)} />
                    </div>
                </Col>
            </Row>
            <Dropdown.Menu className="header-dropdown animate calender-dropdown">
                <div className="header-submenu">
                    <Tabs activeKey={tab} onSelect={e => setTab(e)}>
                        {/* className={disableTab ? "disabled" : null} */}
                        <Tab eventKey={1} title="Quick" style={{ cursor: disableTab ? "not-allowed" : "pointer" }} tabClassName={disableTab ? "disabled" : null}>
                            <QuickSelection
                                onChange={handleRangeChange}
                                rangeList={rangeList}
                                location={props.location}
                                searchParams={searchParams}
                            />
                        </Tab>
                        <Tab eventKey={2} title="Absolute" >
                            <AbsoluteDate
                                farmId={farmId}
                                setShow={() => setShow(!show)}
                                selectedYear={selectedYear}
                            />
                        </Tab>
                    </Tabs>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
};

/* const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ setSearchParams, reportSearchParams, showOverlay, hideOverlay, getSettings }, dispatch)
}); */

/* const mapStateToProps = state => ({
    searchParams: state.analyze.searchParams,
    isToggleRetainDate: state.analyze.isToggleRetainDate,
    timezoneIdentifier: state.farm.currentFarm.timezone_identifier,
    settings: state.user.userSettings,
}); */

export default memo(RangeBox);